import { observer } from 'mobx-react-lite';

import { Table } from '@/components/table';
import { getColumns } from './setup';

export const Lots = observer(({ waybill }: { waybill: cyrian.api.waybills.Waybill }) => {
  const columns = getColumns();

  return <Table rowKey="id" columns={columns} dataSource={waybill?.lotDetails || []} scroll={{ x: 600 }} />;
});
